var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otpWrapper"},[_c('p',{class:_vm.codeStatus,attrs:{"id":"code"},domProps:{"innerHTML":_vm._s(_vm.code)}}),_c('canvas',{attrs:{"id":"pieTimer","width":"20","height":"20"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }